import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconDuplicateProps extends SVGProps<any> {}
export class SVGIconDuplicate extends Component<SVGIconDuplicateProps> {
  render() {
    const { width = 40, height = 40, fill = '#364856', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-back"
        width={`${width}`}
        height={`${height}`}
        viewBox={'0 0 21 21'}
        fill={fill}
        {...rest}
      >
        <g fill="none" stroke={fill} strokeWidth={1.4}>
          <path d="m16.5 10.5v-8c0-1.1045695-.8954305-2-2-2h-8c-1.1045695 0-2 .8954305-2 2v8c0 1.1045695.8954305 2 2 2h8c1.1045695 0 2-.8954305 2-2z" />
          <path d="m4.5 4.50345827h-2c-1.1045695 0-2 .8954305-2 2v7.99654173c0 1.1045695.8954305 2 2 2h.00345528l8.00000002-.0138241c1.1032187-.001906 1.9965447-.8967767 1.9965447-1.9999971v-1.9827205" />
          <path d="m10.5 3.5v6" />
          <path d="m10.5 3.5v6" transform="matrix(0 1 -1 0 17 -4)" />
        </g>
      </SVG>
    );
  }
}
